import React from "react";
import "./Footer.css";
export default function Footer() {
	return (
		<div className="footer-container" id="footer">
			<div className="footer-parent" style={{ margin: "25px auto" }}></div>
		</div>
	);
}
